
<div fxLayout="column" fxLayoutAlign="start" fxLayoutGap="10px">
  <div class="flex-row gap-8 align-center">
    <span class="title">Staff Referral Banners</span>
    @if (editable) {
      <lib-button [disabled]="staffReferralBanners?.length > 4" icon="add" tooltip="Add new banner" (buttonClick)="onAdd()">Add banner</lib-button>
    }
  </div>

  <div fxLayout="row" fxLayoutGap="10px">
    @for (b of staffReferralBanners; track b) {
      <div class="banner">
        <app-campaign-banner-image [editable]="editable" [banner]="b" [maxSize]="maxFileSize" (bannerUploaded)="onBannerUploaded($event)"></app-campaign-banner-image>
        @if (editable) {
          <div class="banner-actions">
            <lib-button variant="icon" (buttonClick)="onRemove(b)" tooltip="Remove banner" icon="close"></lib-button>
          </div>
        }
      </div>
    }
  </div>
</div>